var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionCircle = function SvgQuestionCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 14.667A6.667 6.667 0 1 1 14.667 8 6.674 6.674 0 0 1 8 14.667M8 2.359A5.641 5.641 0 1 0 13.641 8a5.65 5.65 0 0 0-5.64-5.64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 10.052a.513.513 0 0 1-.513-.513 2.37 2.37 0 0 1 .92-1.645c.318-.318.619-.619.619-.92a1.026 1.026 0 0 0-2.052 0 .513.513 0 1 1-1.025 0 2.051 2.051 0 0 1 4.102 0 2.37 2.37 0 0 1-.92 1.645c-.318.319-.618.62-.618.92a.513.513 0 0 1-.513.513M8 11.59a.513.513 0 1 0 0-1.026.513.513 0 0 0 0 1.026"
  })));
};
export default SvgQuestionCircle;